import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { BasicModal, DefaultButton } from 'common/components';

import { FailWithdrawForm, WithdrawError } from '../../_components';
import { actionWithdrawal, getPaymentWithdrawalStatuses, getWithdrawal } from '../../_redux';
import PaymentPage from '../PaymentPage';

const WithdrawalPage = ({
  profile,
  withdrawal,
  withdrawalIsLoaded,
  withdrawalError,
  getWithdrawal,
  getPaymentWithdrawalStatuses,
  withdrawalActionsLoading,
  redirect,
  history,
  match,
  actionWithdrawal,
}) => {
  useEffect(() => {
    getWithdrawal(match.params.id);
  }, [getWithdrawal, match.params.id]);

  const [loading, setLoading] = useState({
    confirm: false,
    reject: false,
    fail: false,
    payout: false,
    execute: false,
  });

  const [isOpen, setIsOpen] = useState(false);
  const [errorMesseage, setErrorMesseage] = useState(withdrawalError);
  const [activeModal, setActiveModal] = useState('fail');

  const handleWithdrawalButtonClick = type => {
    actionWithdrawal(match.params.id, type);
    setLoading({ ...loading, [type]: true });
    setActiveModal(type);
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleRejectWithdrawal = () => {
    toggleModal();
  };

  /* eslint-disable */
  useEffect(() => {
    if (withdrawalError) {
      setErrorMesseage(withdrawalError);
      setLoading({ ...loading, execute: false });
      toggleModal();
    }
  }, [withdrawalError]);
  /* eslint-enable */

  useEffect(() => {
    if (profile.isAdmin || profile.perms.superUserPerm) {
      getPaymentWithdrawalStatuses();
    }
  }, [getPaymentWithdrawalStatuses]);

  const hasAccessToConfirm = profile.perms.confirmWithdraw || profile.perms.managerConfirmWithdraw;

  const hasAccessToExecute = profile.perms.executeWithdraw || profile.perms.managerExecuteWithdraw;

  const Buttons = () => (
    <>
      {hasAccessToConfirm && (
        <>
          {withdrawal.status === 'waiting_confirmation' && withdrawal.flowVersion === 1 && (
            <DefaultButton
              onClick={() => handleWithdrawalButtonClick('confirm')}
              textId="boConfirm"
              butColor="warning"
              disabled={withdrawalActionsLoading}
              loading={loading.confirm}
            />
          )}
          {(withdrawal.status === 'waiting_confirmation' ||
            (withdrawal.status === 'processing' && !withdrawal.isAutomatic)) &&
            hasAccessToExecute &&
            withdrawal.flowVersion === 2 && (
              <DefaultButton
                onClick={() => handleWithdrawalButtonClick('payout')}
                textId="boPayout"
                butColor="warning"
                disabled={withdrawalActionsLoading}
                loading={loading.payout}
              />
            )}
          {withdrawal.status === 'waiting_confirmation' && (
            <DefaultButton
              onClick={() => handleRejectWithdrawal()}
              textId="boReject"
              butColor="error"
              disabled={withdrawalActionsLoading}
              loading={loading.reject}
            />
          )}
        </>
      )}
      {hasAccessToExecute && (
        <>
          {withdrawal.status === 'processing' && withdrawal.flowVersion === 1 && (
            <DefaultButton
              onClick={() => handleWithdrawalButtonClick('payout')}
              textId="boPayout"
              butColor="warning"
              disabled={withdrawalActionsLoading}
              loading={loading.payout}
            />
          )}
          {withdrawal.status === 'processing' && withdrawal.flowVersion === 2 && withdrawal.isAutomatic && (
            <>
              <DefaultButton
                onClick={() => handleWithdrawalButtonClick('payout_via_psp')}
                textId="boPayoutViaPSP"
                butColor="warning"
                disabled={withdrawalActionsLoading}
                loading={loading.payout}
              />
              <DefaultButton
                onClick={() => handleWithdrawalButtonClick('execute')}
                textId="boExecute"
                butColor="success"
                disabled={withdrawalActionsLoading}
                loading={loading.execute}
              />
            </>
          )}
          {withdrawal.status === 'payout' && (
            <>
              <DefaultButton
                onClick={() => handleWithdrawalButtonClick('execute')}
                textId="boExecute"
                butColor="success"
                disabled={withdrawalActionsLoading}
                loading={loading.execute}
              />
              <DefaultButton
                onClick={() => handleWithdrawalButtonClick('fail')}
                textId="boMarkFail"
                butColor="error"
                disabled={withdrawalActionsLoading}
                loading={loading.fail}
              />
            </>
          )}
          {((withdrawal.status === 'processing' && withdrawal.flowVersion === 1) ||
            (withdrawal.status === 'processing' && !withdrawal.isAutomatic && withdrawal.flowVersion === 2)) && (
            <DefaultButton
              onClick={() => handleWithdrawalButtonClick('fail')}
              textId="boMarkFail"
              butColor="error"
              disabled={withdrawalActionsLoading}
              loading={loading.fail}
            />
          )}
        </>
      )}
    </>
  );

  useEffect(() => {
    if (redirect) {
      window.href = '/backoffice/withdrawals/list';
    }
  }, [redirect]);

  return (
    <>
      <PaymentPage
        type="withdrawals"
        captionSlug="boWithdrawal"
        itemId={match.params.id}
        item={withdrawal}
        getItem={getWithdrawal}
        itemIsLoaded={withdrawalIsLoaded}
        Buttons={Buttons}
        history={history}
        hasEditPerm={profile.perms.managerEditWithdraw || profile.perms.editWithdraw}
        hasEditTagsPerm={profile.perms.tagWithdraw || profile.perms.managerTagWithdraw}
        idBackTo="boBackToWithdrawals"
      />

      <BasicModal
        isOpen={isOpen}
        captionId={activeModal === 'fail' ? 'createRejectNotification' : 'boWithdrawFundsError'}
        onRequestClose={toggleModal}>
        {activeModal === 'fail' && <FailWithdrawForm toggleModal={toggleModal} id={withdrawal.id} />}
        {activeModal === 'execute' && <WithdrawError text={errorMesseage} toggleModal={toggleModal} />}
      </BasicModal>
    </>
  );
};

WithdrawalPage.propTypes = {
  profile: PropTypes.object.isRequired,
  withdrawal: PropTypes.object.isRequired,
  withdrawalIsLoaded: PropTypes.bool.isRequired,
  getWithdrawal: PropTypes.func.isRequired,
  getPaymentWithdrawalStatuses: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  actionWithdrawal: PropTypes.func.isRequired,
  withdrawalActionsLoading: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  withdrawalError: PropTypes.string.isRequired,
  redirect: PropTypes.bool.isRequired,
};

export default compose(
  withRouter,
  connect(
    state => ({
      profile: state.user.profile,
      withdrawal: state.backoffice.payments.withdrawal,
      withdrawalIsLoaded: state.backoffice.payments.withdrawalIsLoaded,
      withdrawalActionsLoading: state.backoffice.payments.withdrawalActionsLoading,
      withdrawalError: state.backoffice.payments.withdrawalError,
      redirect: state.backoffice.common.redirect,
    }),
    {
      getWithdrawal: id => getWithdrawal.request(id),
      actionWithdrawal: (id, actionType) => actionWithdrawal.request(id, actionType),
      getPaymentWithdrawalStatuses: () => getPaymentWithdrawalStatuses.request(),
    }
  )
)(WithdrawalPage);
export { WithdrawalPage };
